/**
 * RefreshIcon — sanitized from `assets/newSvg/refresh.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function RefreshIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M1.49775579,12.0822 C1.48857188,10.8151286 2.84466573,10.095458 3.87669008,10.6758264 L3.98994,10.7457 L6.66778,12.55 C8.09185243,13.5094486 7.20577883,15.6955059 5.56894709,15.4646139 L5.43084,15.4397 L5.32236,15.4159 C6.25566,17.2388 7.92713,18.6735 10.0587,19.2447 C13.4095,20.1425 16.8422,18.6227 18.4971,15.7511 C18.9107,15.0333 19.8279,14.7868 20.5457,15.2004 C21.2634,15.6141 21.51,16.5312 21.0963,17.249 C18.7802,21.2682 13.9782,23.4007 9.2822,22.1425 C5.0775,21.0158 2.15918,17.4918 1.59671,13.4406 C1.53464,12.9935 1.5012,12.5399 1.49775579,12.0822 Z M2.90375,6.75109 C5.22,2.73217 10.0218,0.599762 14.7177,1.85801 C18.9224,2.98466 21.8407,6.50864 22.4032,10.5599 C22.4653,11.007 22.4987,11.4606 22.5020958,11.9182 C22.5113553,13.1852714 21.155227,13.904942 20.1232449,13.3246632 L20.01,13.2548 L17.332,11.4504 C15.9079568,10.4909514 16.7938986,8.30499822 18.4306956,8.5357485 L18.5688,8.56065 L18.6775,8.58449 C17.7442,6.76159 16.0727,5.32692 13.9412,4.75579 C10.5905,3.85797 7.15788,5.37769 5.50296,8.24911 C5.08929,8.96687 4.17209,9.21338 3.45434,8.79971 C2.73659,8.38604 2.49008,7.46884 2.90375,6.75109 Z"
        fill={color}
      />
    </Svg>
  );
}

export default RefreshIcon;
